import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { deepOrange, blue, green } from '@material-ui/core/colors';
import Chip from '@material-ui/core/Chip';
import Avatar from '@material-ui/core/Avatar';
import PersonIcon from '@material-ui/icons/Person';

const useStyles = makeStyles(theme => {
  return {
    ccAvatar: {
      background: deepOrange[900],
      color: ['#fff', '!important']
    },
    ccChip: {
      background: deepOrange[500],
      color: '#fff',
    },
    dxAvatar: {
      background: blue[900],
      color: ['#fff', '!important']
    },
    dxChip: {
      background: blue[500],
      color: '#fff'
    },
    coderAvatar: {
      background: green[900],
      color: ['#fff', '!important']
    },
    coderChip: {
      background: green[500],
      color: '#fff'
    }
  };
});

// https://www.merriam-webster.com/dictionary/delible
const CoderChip = ({
  coder,
  onDelete,
  isDelible = false
}) => {
  const classes = useStyles();

  const conditionalDelete = isDelible ? { onDelete } : {};

  return (
    <Chip
      {...conditionalDelete}
      className={classes.coderChip}
      size="small"
      avatar={(
        <Avatar className={classes.coderAvatar}>
          <PersonIcon />
        </Avatar>
      )}
      label={coder.name || coder.label}
    />
  );
};

CoderChip.propTypes = {
  isDelible: PropTypes.bool.isRequired,
  onDelete: PropTypes.func,
  coder: PropTypes.shape({
    name: PropTypes.string
  }).isRequired
};

export default CoderChip;
